import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';

export interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { accounts, inProgress } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    // If not authenticated and not in progress, redirect to login
    if (accounts.length === 0 && inProgress === InteractionStatus.None) {
      navigate('/login');
    }
  }, [accounts, inProgress, navigate]);

  // Show loading while authentication is in progress
  if (inProgress !== InteractionStatus.None) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary-500 border-t-transparent mx-auto mb-4"></div>
          <p className="text-neutral-600">Authenticating...</p>
        </div>
      </div>
    );
  }

  // If not authenticated, don't render children (will redirect via useEffect)
  if (accounts.length === 0) {
    return null;
  }

  return <>{children}</>;
}
